import $ from "jquery";
import Isotope from "isotope-layout";
import "isotope-packery";
import plyr from "plyr";

window.$ = $;
window.jQuery = $;

import '../vendor/jquery.bxslider';

/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const showModal = function(title, content) {
  content = $("<textarea/>").html(content).text();

  $('.reveal-overlay').remove();
  $('#js_modal').remove();
  const $modal = $(`\
<div class="reveal reveal-tile" id="js_modal" data-reveal data-reset-on-close="true" data-close-on-click="true">
  <h2>${title}</h2>

  ${content}
  
  <button class="close-button" data-close aria-label="Close reveal" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>`);
  
  $('body').append($modal);

  const modal = new Foundation.Reveal($('#js_modal'));
  return modal.open();
};

$(function() {
  const hash = location.hash.replace('#', '');

  $(document).foundation();

  // Form Honeypots
  setTimeout(() => {
    $('.enquire-form, .join-form, .guest-login-form, .js-property-enquire-form').append('<input type=\"hidden\" name=\"hg8y77gt\" value=\"valid\" />');
  }, 500);

  const loggedIn = () => window.RS && (window.RS.user > 0);

  // Sticky Header
  const updateStickyHeader = function() {
    if (!$('body').hasClass('no-sticky-header')) {
      const winTop = $(window).scrollTop();
      const triggerOffset = $(window).height() * 0.6;

      if (winTop >= triggerOffset) {
        return $("body").addClass("stick-header");
      } else {
        return $("body").removeClass("stick-header");
      }
    }
  };

  $(window).scroll( () => updateStickyHeader());
  // Update it on render too
  updateStickyHeader();

  $('.js-menu-sticky').each(function() {
    const $menu = $(this);
    let $cloned = null;

    return $(window).scroll(function() {
      // Show when main nav is sticking and the menu has been passed
      if ($('body').hasClass('stick-header') && ($(this).scrollTop() > ($menu.position().top + $menu.height()))) {
        if (!$cloned) {
          $cloned = $menu.clone().insertAfter($menu);
        }

        return $cloned.addClass('menu-bar-stick');
      } else {
        if ($cloned) { 
          $cloned.removeClass('menu-bar-stick');
          $cloned.remove();
          return $cloned = null;
        }
      }
    });
  });
  
  const getCookie = function(name) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    if (v) { return v[2]; } else { return null; }
  };

  const setCookie = function(name, value, days) {
    const d = new Date;
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000 * days));
    document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
  };

  // Currency handling
  const saveCurrency = function(c) {
    window.RS.currency = c;
    setCookie('currency', c, 90);
    return location.reload();
  };

  const loadCurrency = function() {
    let currency = 'EUR';
    
    // If user is logged in, ignore any cookies
    if (window.RS.user && (window.RS.user > 0) && window.RS.currency) {
      ({
        currency
      } = window.RS);
    } else if (['GBP', 'EUR', 'USD'].indexOf(getCookie('currency')) >= 0) {
      currency = getCookie('currency');
    }
    
    window.RS.currency = currency;
    $('#currency').val(currency);
    return currency;
  };

  $('#currency').change(() => saveCurrency($('#currency').val()));

  if (window.RS) {
    loadCurrency();
    $('#currency').show();
  }

  // Smooth scroll hash
  (function(document, history, location) {
    const HISTORY_SUPPORT = !!(history && history.pushState);
    const anchorScrolls = { 
      ANCHOR_REGEX: /^#[^ ]+$/,
      init() {
        this.scrollToCurrent();
        window.addEventListener('hashchange', this.scrollToCurrent.bind(this));
        document.body.addEventListener('click', this.delegateAnchors.bind(this));
      },
      getFixedOffset() {
        if ($(window).width() > 768) {
          return 120;
        } else {
          return 64;
        }
      },
      scrollIfAnchor(href, pushToHistory) {
        let match = undefined;
        let rect = undefined;
        let anchorOffset = undefined;
        if (!this.ANCHOR_REGEX.test(href)) {
          return false;
        }
        match = document.getElementById(href.slice(1));
        if (match) {
          rect = match.getBoundingClientRect();
          anchorOffset = (window.pageYOffset + rect.top) - this.getFixedOffset();
          window.scrollTo(window.pageXOffset, anchorOffset);
          // Add the state to history as-per normal anchor links
          if (HISTORY_SUPPORT && pushToHistory) {
            history.pushState({}, document.title, location.pathname + href);
          }
        }
        return !!match;
      },
      scrollToCurrent() {
        this.scrollIfAnchor(window.location.hash);
      },
      delegateAnchors(e) {
        const elem = e.target;
        if ((elem.nodeName === 'A') && this.scrollIfAnchor(elem.getAttribute('href'), true)) {
          e.preventDefault();
        }
      }
    };
    window.addEventListener('DOMContentLoaded', anchorScrolls.init.bind(anchorScrolls));
  })(window.document, window.history, window.location);

  // Home
  const fisherYates = function(arr) {
    let i = arr.length;
    if (i === 0) { return false; }

    while (--i) {
      var j = Math.floor(Math.random() * (i+1));
      var tempi = arr[i];
      var tempj = arr[j];
      arr[i] = tempj;
      arr[j] = tempi;
    }
    return arr;
  };

  //# Home - Our Story
  if ($('#ourStoryModal').length) {
    const ourStoryModal = new Foundation.Reveal($('#ourStoryModal'));
    // Show on load if hash in url
    if (hash === "story") {
      ourStoryModal.open();
    }

    $('.our-story-link').click(() => ourStoryModal.open());
  }

  //# Home - Slider
  const $homeSlider = $('.home-slider ul').bxSlider({
    auto: true,
    mode: 'fade',
    pause: 6000,
    speed: 600,
    randomStart: true,
    controls: false,
    adaptiveHeight: true,
    easing: 'ease-in-out',
    touchEnabled : (navigator.maxTouchPoints > 0)
  });
  
  $('.home-slider .bx-pager').hover(() => $homeSlider.stopAuto());
  $('.home-slider .bx-pager').mouseleave(() => $homeSlider.startAuto());

  //# Home - The Services
  const $serviceSlider = $('.the-services ul').bxSlider({
    auto: true,
    autoControls: true,
    autoHover: true,
    stopAutoOnClick: true,
    tickerHover: true,
    adaptiveHeight: true,
    pause: 7000,
    touchEnabled : (navigator.maxTouchPoints > 0)
  });
  
  $('.the-services .bx-pager').hover(() => $serviceSlider.stopAuto());
  $('.the-services .bx-pager').mouseleave(() => $serviceSlider.startAuto());

  //# Home - Testimonials
  $('.testimonials ul').bxSlider({
    auto: true,
    autoHover: true,
    tickerHover: true,
    pause: 5000,
    pager: false,
    touchEnabled : (navigator.maxTouchPoints > 0)
  });

  //# Home - Experiences
  const disperseExperiences = function(exps) {
    const dispersed = [];
    const duplicates = [];
    for (var e of Array.from(exps)) {
      var existing = dispersed.filter(f => f.title === e.title);
      if (existing.length > 0) {
        duplicates.push(e);
      } else {
        dispersed.push(e);
      }
    }
    
    return dispersed.concat(duplicates);
  };

  const removeDuplicates = function(exps) {
    const uniques = [];
    for (var e of Array.from(exps)) {
      if (uniques.filter(f => f.title === e.title).length === 0) {
        uniques.push(e);
      }
    }
    
    return uniques;
  };

  if (window.experiences && $('#experiences')) {
    const experiences = disperseExperiences(window.experiences);
    const $experiencePopup = $('#experienceModal');
    const experiencePopup = new Foundation.Reveal($experiencePopup);
    const $experiences = $('.experiences-grid');
    const $experiencesGrid = new Isotope($experiences[0], {
      layoutMode: "packery",
      itemSelector: '.experience'});
    let displaySizes = {
      1: ["2x1"],
      2: ["2x1", "2x1"],
      3: ["2x1", "1x1", "1x1"],
      4: ["1x2", "1x2", "2x1", "2x1"],
      5: ["1x2", "1x1", "2x1", "1x1", "2x1"],
      6: ["1x2", "1x1", "2x1", "1x1", "1x1", "1x1"],
      7: ["1x2", "1x1", "2x1", "1x1", "1x2", "1x2", "2x1"],
      8: ["1x2", "1x1", "2x1", "1x1", "1x1", "2x1", "1x2", "1x1"]
    };

    let pageSize = 8;
    if ($(window).width() < 768) {
      if (!$experiences.hasClass('experiences-grid--show-all')) {
        pageSize = 3;
      }

      displaySizes = { 
        1: ["2x1"],
        2: ["1x1", "1x1"],
        3: ["2x1", "1x1", "1x1"],
        4: ["2x1", "2x1", "2x1", "2x1"],
        5: ["2x1", "2x1", "2x1", "2x1", "2x1"],
        6: ["2x1", "2x1", "2x1", "2x1", "2x1", "2x1"],
        7: ["2x1", "2x1", "2x1", "2x1", "2x1", "2x1", "2x1"],
        8: ["2x1", "2x1", "2x1", "2x1", "2x1", "2x1", "2x1", "2x1"]
      };
    }

    let filter = "*";
    let page = 1;
    let moreAvailable = false;
    let autoReloadTimer = null;

    const filteredExperiences = () => experiences.filter(function(e) {
      if (filter === "*") {
        return true;
      } else {
        let match = false;

        // Split to support multiple filters separated by ','
        filter.split(',').forEach(function(f) {
          if ($.inArray(f, e.tags) !== -1) { return match = true; }
        });

        return match;
      }
    });

    moreAvailable = function(exps) {
      const first = (page - 1) * pageSize;
      const paged = exps.slice(first, first + pageSize);
      return (first + paged.length) < exps.length;
    };

    const displayExperiences = function() {
      const filtered = filteredExperiences();
      const total = filtered.length;
      
      // Clear existing items
      $experiencesGrid.remove($experiencesGrid.getItemElements());
      const $items = [];

      let shuffled = fisherYates(filtered);
      // Remove duplicates if there is enough to satisfy multiple pages of items
      if (shuffled && (shuffled.length > pageSize)) {
        shuffled = removeDuplicates(shuffled);
      }

      // Select first page of elements
      if (shuffled && (shuffled.length > 0)) {
        shuffled = shuffled.slice(0, Math.min(total, pageSize));
      }

      for (let idx = 0; idx < shuffled.length; idx++) {
        var e = shuffled[idx];
        var attrs = "";

        if (e.path) {
          attrs = `data-path=\"${e.path}\"`;
        } else if (e.modal) {
          attrs = `data-modal=\"${e.modal}\"`;
        }

        var $elem = $(`\
<div class="experience experience-${displaySizes[shuffled.length][idx]}" data-property="${e.property}" ${attrs}>
  <a href="javascript:void(0)" style="background-image: url('${e.image}');">
    <span>${e.title}</span>
  </a>
</div>`);

        $elem.click(function() {
          if ($(this).data('path')) {
            return window.location = $(this).data('path');
          } else if ($(this).data('modal')) {
            return showTileModal($(this), $(this).data('modal'));
          }
        });

        $items.push($elem[0]);
      }

      // $('.experiences-load-more').toggle(moreAvailable(filtered))
      if (total > pageSize) {
        $('.experiences-load-more').show();
      } else {
        $('.experiences-load-more').hide();
      }

      if (autoReloadTimer) {
        clearInterval(autoReloadTimer);
      }

      autoReloadTimer = setInterval((function() {
        if ((total > pageSize) && $('.experiences-load-more').length) {
          return $('.experiences-load-more').click();
        }
      }), 12000);
      
      $experiencesGrid.insert($items);
    };
      
    $('.experiences-filters a').click(function() {
      $('.experiences-filters a').each(function() {
        return $(this).removeClass('active');
      });

      // Update mobile dropdown button
      $('.experiences-filters button').text($(this).text());
      $('#experiences-filters-dropdown').foundation('close');

      filter = $(this).data('filter');
      page = 1;
      $(this).addClass('active');
      return displayExperiences();
    });

    $('.experiences-load-more').click(function() {
      if (moreAvailable(filteredExperiences())) {
        page += 1;
      } else {
        page = 1;
      }
      
      return displayExperiences();
    });

    displayExperiences();
  }
  
  var showTileModal = ($tile, modal) => showModal($tile.text(), modal);
  
  // Enquire & Guest Login Form Switch
  $('#guestLoginMode').click(function() {
    $('#enquiryForm').hide();
    $('#guestLoginForm').show();
    $(this).removeClass('hollow');
    $('#enquiryMode').addClass('hollow');
    return $('#enquiryModeInfo').html($(this).data('text'));
  });

  $('#enquiryMode').click(function() {
    $('#enquiryForm').show();
    $('#guestLoginForm').hide();
    $(this).removeClass('hollow');
    $('#guestLoginMode').addClass('hollow');
    return $('#enquiryModeInfo').html($(this).data('text'));
  });

  if ((hash === 'register') && ($('#guestLoginMode').length > 0)) {
    $('#guestLoginMode').click();
  }
    
    
  // Mobile Menu
  $('.sticky-menu-button').click(function() {
    $(this).find('.bar').toggleClass('animate');
    return $('.public-mobile').toggleClass('public-mobile--expanded');
  });

  $('.public-mobile nav a.nav-action').click(function() {
    $('.sticky-menu-button').find('.bar').removeClass('animate');
    return $('.public-mobile').removeClass('public-mobile--expanded');
  });

  //# Mobile Menu for Submenus
  $('body').on('click', '.mobile-menu-button', function() {
    const $bar = $(this).find('.bar');
    $bar.toggleClass('animate');
    const $content = $(this).parent().parent().find('.menu-bar-content');
    $content.find('a').click(function() {
      $bar.removeClass('animate');
      return $content.slideUp();
    });
    return $content.slideToggle();
  });

  
  // Live Chat
  //  $('.live-chat').hide()
  //  checkCrispAvailable = ->
  //    if $crisp.is("website:available")
  //      $('.live-chat').show()
  //
  //  if $crisp and $crisp.is
  //    checkCrispAvailable()
  //  else
  //    window.CRISP_READY_TRIGGER = ->
  //      checkCrispAvailable()
  //
  //  $('.live-chat').click ->
  //    if $crisp
  //      $crisp.push(['do', 'chat:open']);

  // Registration Form
  // $('.registration-form-async').on 'submit', (e) ->
  //   e.preventDefault()
  //   e.stopPropagation()
  //   $form = $(this)
  // 
  //   $.ajax(
  //     url: '/registrations.json'
  //     type: 'post'
  //     dataType: 'json'
  //     data: $form.serialize()
  //     success: (data) ->
  //       $form.parent().find('.callout').remove()
  //       if data.success
  //         $form.hide()
  //         $form.parent().append("""<div class="callout success"><p>#{data.message}</p></div>""")
  //       else
  //         $form.before("""<div class="callout alert"><p>#{data.message}<p></div>""")
  // 
  //     error: (xhr, err) ->
  //       alert("An error occured when processing your registration, please try again later: " + err)
  //   )

  //# Login / Register Overlay
  $('.overlay-tabs a').click(function(e) {
    e.preventDefault();
    e.stopPropagation();

    $('.overlay-tabs a').each(function() {
      $(this).removeClass('active');
      return $($(this).attr('href')).hide();
    });

    $(this).addClass('active');
    return $($(this).attr('href')).show();
  });


  //# Property - Testimonials
  $('.property-testimonials ul').bxSlider({
    auto: true,
    autoHover: true,
    tickerHover: true,
    pause: 5000,
    pager: false,
    touchEnabled : (navigator.maxTouchPoints > 0)
  });
  
  //# Property - Video
  $('body').on('click', '.js-play-property-video', function() {
    const youtubeId = $(this).data('video-id');
    const $tile = $('.splash-tile-video');
    $(window).scrollTop(0);

    if (!$tile.hasClass('splash-tile-video--playing')) {
      const original = $tile.html();
      $tile.addClass('splash-tile-video--playing');
      $tile.html(`<div class="js-player" data-plyr-provider="youtube" data-plyr-embed-id="${youtubeId}" data-plyr-config='{ "autoplay": true }'></div>`);
      const players = plyr.setup('.js-player');

      return Array.from(players).map((player) =>
        player.on('ended', function(event) {
          $tile.html(original);
          return $tile.removeClass('splash-tile-video--playing');
        }));
    }
  });
      
  //# Feature Slider
  const $featureSlider = $('.feature-slider ul').bxSlider({
    auto: true,
    autoControls: true,
    stopAutoOnClick: true,
    adaptiveHeight: true,
    pager: true,
    pause: 7000,
    touchEnabled : (navigator.maxTouchPoints > 0)
  });
  
  if (typeof mixpanel !== 'undefined') {
    return mixpanel.track_forms('.js-property-enquire-form', 'Submit Property Enquiry');
  }
});
      

//# Responsive Tables

$(document).ready(function() {
  let switched = false;

  const updateTables = function() {
    if (($(window).width() < 767) && !switched) {
      switched = true;
      $('table.responsive').each(function(i, element) {
        splitTable($(element));
      });
      return true;
    } else if (switched && ($(window).width() > 767)) {
      switched = false;
      $('table.responsive').each(function(i, element) {
        unsplitTable($(element));
      });
    }
  };

  var splitTable = function(original) {
    original.wrap('<div class=\'table-wrapper\' />');
    const copy = original.clone();
    copy.find('td:not(:first-child), th:not(:first-child)').css('display', 'none');
    copy.removeClass('responsive');
    original.closest('.table-wrapper').append(copy);
    copy.wrap('<div class=\'pinned\' />');
    original.wrap('<div class=\'scrollable\' />');
    setCellHeights(original, copy);
  };

  var unsplitTable = function(original) {
    original.closest('.table-wrapper').find('.pinned').remove();
    original.unwrap();
    original.unwrap();
  };

  var setCellHeights = function(original, copy) {
    const tr = original.find('tr');
    const tr_copy = copy.find('tr');
    const heights = [];
    tr.each(function(index) {
      const self = $(this);
      const tx = self.find('th, td');
      tx.each(function() {
        const height = $(this).outerHeight(true);
        heights[index] = heights[index] || 0;
        if (height > heights[index]) {
          heights[index] = height;
        }
      });
    });
    tr_copy.each(function(index) {
      $(this).height(heights[index]);
    });
  };

  $(window).on('load', updateTables);
  $(window).on('redraw', function() {
    switched = false;
    updateTables();
  });
  
  // An event to listen for
  $(window).on('resize', updateTables);
});


//# Re-usable Tile Grid

$(document).ready(() => $('.large-tile-grid').each(function() {
  $(this).isotope({
    itemSelector: '.large-tile-grid__tile',
    percentPosition: true,
    layoutMode: 'packery'
  });

  const touch = Array.from(document.documentElement).includes("ontouchstart");
  if ($(this).hasClass('large-tile-grid--modal') && (($(window).width() < 1024) || touch)) {
    return $('.large-tile-grid__tile').on('click', function() {
      console.log($(this).find('h3').text());
      return showModal($(this).find('h3').text(), $(this).find('.large-tile-grid__caption').html());
    });
  }
}));
    
